import escapeHTML from 'escape-html';

import {MarkupFlavour, HTML_TAG_LINE_BREAK} from '#src/constants.js';

export function createHtmlTag(type, dataset, {isMarkdown = false, isNonClosing = false, variant} = {}) {
  const list = [
    ['type', type],
    ['meta-flavour', isMarkdown ? MarkupFlavour.Markdown : MarkupFlavour.BBCode]
  ];

  if (variant) {
    list.push(['meta-variant', variant]);
  }

  const s = Object.entries(dataset).concat(list).reduce((acc, [k, v]) => `${acc} data-${k}="${v}"`, '');

  return `<div${s}${isNonClosing ? '>' : '/>'}`;
}

export function toBase64(s) {
  return Buffer.from(s).toString('base64');
}

export function fromBase64(s) {
  return Buffer.from(s, 'base64').toString();
}

export function escapeRegExp(text, {u = true} = {}) {
  text = text.replace(/[[\]{}()*+?.,\\^$|#\s]/gu, '\\$&');

  if (!u) {
    text = text.replace(/-/gu, '\\-');
  }

  return text;
}

export function toHTML(text) {
  text = escapeHTML(text).replace(/\n/gu, HTML_TAG_LINE_BREAK);

  return text;
}
